import React, {
  MouseEvent as ReactMouseEvent,
  KeyboardEvent as ReactKeyboardEvent,
} from "react";

import {
  QuestionnaireCardContainer,
  QuestionnaireCardTitleContainer,
  QuestionnaireCardDateContainer,
  QuestionnaireCardTitleButton,
  Icon,
} from "./QuestionnaireCardStyles";
import { ActionMenu } from "../ActionMenu";
import { SelectedIcon } from "../../Icons";

export interface Props {
  id: string;
  questionnaireTitle: string;
  questionnaireStarred: boolean;
  questionnaireTitleOnClick: (
    event: ReactMouseEvent | ReactKeyboardEvent
  ) => void;
  questionnaireShortCode?: string;
  questionnaireProject?: string;
  questionnaireOwner: string;
  questionnaireCreated: string;
  questionnaireLastOpened: string;
  questionnaireAccess: string;
  questionnaireActions?: React.ComponentProps<typeof ActionMenu>;
  displayExternalLinkIcon?: boolean;
  dataTestId: string;
}

export const QuestionnaireCard = (props: Props) => {
  return (
    <QuestionnaireCardContainer
      $questionnaireStarred={props.questionnaireStarred}
      data-testid={props.dataTestId}
      id={props.id}
    >
      <QuestionnaireCardTitleContainer>
        <QuestionnaireCardTitleButton
          onClick={props.questionnaireTitleOnClick}
          className="ons-header__title"
        >
          {props.questionnaireTitle}
          {props.displayExternalLinkIcon && (
            <Icon data-testid="open-in-new-icon" className="ons-u-fs-xl">
              <SelectedIcon iconType="OpenInNew" classes="ons-icon--l" />
            </Icon>
          )}
        </QuestionnaireCardTitleButton>
        {props.questionnaireActions && (
          <div>
            <ActionMenu
              text={props.questionnaireActions.text}
              menuPosition="right"
              menuWidth="wide"
              itemsList={props.questionnaireActions.itemsList}
              dataTestId={props.questionnaireActions.dataTestId}
              classes={props.questionnaireActions.classes}
            />
          </div>
        )}
      </QuestionnaireCardTitleContainer>
      {props.questionnaireShortCode && (
        <p>
          <strong>Short code: </strong>
          {props.questionnaireShortCode}
        </p>
      )}
      {props.questionnaireProject && (
        <p>
          <strong>Project: </strong>
          {props.questionnaireProject}
        </p>
      )}
      <p>
        <strong>Owner: </strong>
        {props.questionnaireOwner}
      </p>
      <QuestionnaireCardDateContainer>
        <p className="ons-u-mr-l">
          <strong>Created: </strong>
          {props.questionnaireCreated}
        </p>
        <p>
          <strong>Last opened: </strong>
          {props.questionnaireLastOpened}
        </p>
      </QuestionnaireCardDateContainer>
      <p>
        <strong>Access: </strong>
        {props.questionnaireAccess}
      </p>
    </QuestionnaireCardContainer>
  );
};
